import _ from 'lodash';

const columns = [
  { title: 'Title', dataKey: 'title' },
  { title: 'Description', dataKey: 'desc' },
]

const loanPurposeHeader = [
  { title: 'Loan Purpose', dataKey: 'title' },
  { title: 'Amount', dataKey: 'desc' },
]

const servicingHeader = [
  { title: 'Loan Term', dataKey: 'title' },
  { title: 'Maximum Affordable Loan Amount', dataKey: 'desc' },
]

export const quotePdf = (application, quoteType = 'normal') => {
  const isLowScoreProtection = (item, errorMessage = 'Not Applicable') => quoteType === 'lowScore' ? errorMessage : item;

  const isNullSafety = (data) => {
    if ((`${data}`).indexOf('null') > -1) {
      return 'Not Applicable'
    } else {
      return data;
    }
  };
  /**
   * Content for the first table
  */
  const loanPurposes = application.loanPurpose.map(({ purpose, amount, recipient }) => ({ title: purpose, desc: `Amount: $${amount}\nPaid to: ${recipient}` }))
  const totalLoan = application.loanPurpose.reduce((a, b) => ({amount: Number(a.amount) + Number(b.amount)})).amount
  const establishmentFee = isLowScoreProtection((application.quoteData.establishmentFee).toFixed(2), 0);
  const totalWithFees = Number(totalLoan) + Number(establishmentFee) + Number(application.brokerServiceFee);
  const loanTerm = isLowScoreProtection(application.quoteData.termYears);
  const repayment = isLowScoreProtection(`$${(application.quoteData.repaymentAmount || 0.00).toFixed(2)}/${application.quoteData.repaymentFrequency}`);
  const interestRate = isLowScoreProtection(`${(application.quoteData.interestRate * 100).toFixed(2)}%`);
  const brokerFee = isNullSafety(application.brokerServiceFee);
  const firstTable = [
    ...loanPurposes,
    { title: 'Total Loan Amount', desc: `$${totalLoan}` },
    { title: 'Establishment Fee', desc: `$${establishmentFee}` },
    { title: 'Broker Assistance Fee', desc: `$${brokerFee}` },
    { title: 'Total Including all fees', desc: `$${totalWithFees}` },
  ]

  /**
    * Content for the Second table
  */

  const secondTable = [
    { title: 'Loan Term', desc: `${loanTerm} years` },
    { title: 'Repayment', desc: `${repayment}` },
    { title: 'Interest Rate', desc: interestRate },
  ]

  /**
   * Content for the Third table
  */
  const driversLicence = application.noDriverLicense === true ? 'No Driver`s Licence' : application.driverLicenseNumber
  const thirdTable = [
    { title: 'Full name', desc: application.name },
    { title: 'Date of Birth', desc: application.dob },
    { title: 'Drivers Licence Number', desc: driversLicence },
    { title: 'Email', desc: application.email },
    { title: 'Mobile Number', desc: application.mobileNumber },
    { title: 'Residency Status', desc: application.residencyStatus },
  ]

  const addressTable = [
    { title: 'Current Address', desc: application.address },
    { title: 'Time at Current Address', desc: `${application.timeAtAddressYears} year(s) and ${application.timeAtAddressMonths} month(s)` },
    { title: 'Current Address Type', desc: isNullSafety(application.residenceType) },
    { title: 'Previous Address', desc: isNullSafety(application.previousAddress) },
    { title: 'Time at Previous Address', desc: isNullSafety(`${application.previousTimeAtAddressYears} year(s) and ${application.previousTimeAtAddressMonths} month(s)`) },
  ]

  /**
   * Content for the Fourth table
  */

  const fourthTable = [
    // { title: 'Name', desc: application.nextContactName },
    // { title: 'Mobile', desc: application.nextContactNumber },
    { title: 'Name', desc: '' },
    { title: 'Mobile', desc: '' },
  ]

  /**
   * Content for the Fifth table
  */

  const fifthTable = [
    { title: 'Current employment type', desc: application.currentEmploymentType },
    { title: 'Time at employment', desc: `${application.currentEmploymentTimeYears} year(s) and ${application.currentEmploymentTimeMonths} month(s)` },
    { title: 'Previous employment type', desc: isNullSafety(application.previousEmploymentType) },
    { title: 'Time at previous employment', desc: isNullSafety(`${application.previousEmploymentTimeYears} year(s) and ${application.previousEmploymentTimeMonths} month(s)`) },
  ]

  /**
   * Content for the Sixth table
  */

  const sixthTable = [
    { title: 'Business name/Income source', desc: application.primaryIncomeName },
    { title: 'Income type', desc: application.primaryIncomeType },
    { title: 'Occupation', desc: application.primaryIncomeOccupation },
    { title: 'Time at Employment', desc: `${application.currentEmploymentTimeYears} year(s) and ${application.currentEmploymentTimeMonths} month(s)` },
    { title: 'Industry', desc: application.primaryIncomeIndustry },
    { title: 'After-tax amount', desc: `$${application.primaryIncomeAmount}/${application.primaryIncomeFrequency}` },
  ]

  /**
   * Content for the Seventh table
  */

  const seventhTable = application.additionalIncome.reduce((total, item, index) => {
    const current = [
      { title: `Income type`, desc: item.type },
      { title: `Business name/Income source`, desc: item.name },
      { title: `After-tax amount`, desc: `$${item.amount}/${item.frequency}` },
      { title: '', desc: '' },
    ];
    return [...total, ...current]
  }, [])

  /**
   * Content for the Eight table
  */

  const eightTable = application.debts.map((debt) => {
    if (debt.type === 'Credit Card/Overdraft') {
      return [
        { title: 'Debt Type', desc: 'Credit Card' },
        { title: 'Financial Institution', desc: debt.financialInstitution },
        { title: 'Limit', desc: `$${debt.limit}` },
        { title: 'Amount Owing', desc: `$${debt.amountOwing}` },
        { title: '', desc: '' },
      ]
    } else if (debt.type === 'Personal loan/Car loan') {
      return [
        { title: 'Debt Type', desc: 'Personal Loan' },
        { title: 'Financial Institution', desc: debt.financialInstitution },
        { title: 'Repayment Amount', desc: `$${debt.repaymentAmount}/${debt.repaymentFrequency}` },
        { title: 'Amount Owing', desc: `$${debt.amountOwing}` },
        { title: '', desc: '' },
      ]
    } else if (debt.type === 'Mortgage') {
      return [
        { title: 'Debt Type', desc: 'Mortgage' },
        { title: 'Financial Institution', desc: debt.financialInstitution },
        { title: 'Repayment Amount', desc: `$${debt.repaymentAmount}/${debt.repaymentFrequency}` },
        { title: 'Joint Mortgage', desc: debt.jointMortgage },
        { title: '', desc: '' },
      ]
    }
  })

  /**
   * Content for the Ninth table
  */

  const ninthTable = [
    { title: 'Rent Payment', desc: `$${application.rentAmount || 0}/${application.rentFrequency || 'Weekly'}` },
    { title: 'Everyday Living Expenses', desc: `$${application.livingExpenses}/Monthly` },
  ]

  /**
   * Content for the Tenth table
  */

  const tenthTable = [
    { title: 'Relationship Status', desc: application.relationshipStatus },
    { title: 'Partner Income', desc: isNullSafety(`$${(application.partnerIncome)}`) },
    { title: 'Number of Dependants', desc: application.dependants },
  ]

  /**
   * Content for the eleventh table
  */

  const eleventhTable = [
    { title: '2 Years', desc: isLowScoreProtection(`$${(application.quoteData.maxLoans['2y'] || 0).toFixed(0)}`) },
    { title: '3 Years', desc: isLowScoreProtection(`$${(application.quoteData.maxLoans['3y'] || 0).toFixed(0)}`) },
    { title: '5 Years', desc: isLowScoreProtection(`$${(application.quoteData.maxLoans['5y'] || 0).toFixed(0)}`) },
  ]

  /*eslint-disable*/
  const doc = new jsPDF();
  /* eslint-enable */
  const additionalNotes = application.additionalNotes === null ? 'No notes' : application.additionalNotes
  const notes = doc.splitTextToSize(additionalNotes, 180); // for addiitonal notes text wrap
  doc.setFontSize(22);

  // Set title and first table
  doc.text('SocietyOne Personal Loan Application Form', 14, 20);

  // array of tables

  // First table
  doc.autoTable(loanPurposeHeader, firstTable, { startY: 30 });
  doc.setFontSize(14);
  // previous refers to the table just drawn
  doc.text('Application Details', 14, doc.autoTable.previous.pageStartY - 4);

  // Second table
  doc.autoTable(columns, secondTable, { startY: doc.autoTable.previous.finalY + 5 });
  doc.setFontSize(14);

  // increase font size for heading
  doc.setFontSize(22);
  doc.text('Borrower Personal Details', 14, doc.autoTable.previous.finalY + 12);

  // decrease font size for title
  // Third Table
  doc.autoTable(columns, thirdTable, { startY: doc.autoTable.previous.finalY + 15 });
  doc.setFontSize(14);

  doc.autoTable(columns, addressTable, { startY: doc.autoTable.previous.finalY + 15 })
  doc.text('Address Details', 14, doc.autoTable.previous.pageStartY - 5);

  // decrease font size for title
  // Fourth Table
  doc.autoTable(columns, fourthTable, { startY: doc.autoTable.previous.finalY + 15 });

  doc.setFontSize(14);
  doc.text('Next Point of Contact', 14, doc.autoTable.previous.pageStartY - 2);

  // add a new page
  doc.addPage();
  doc.setFontSize(22);
  doc.text('Borrower Financials', 14, 20);

  // Fifth Table
  doc.autoTable(columns, fifthTable, { startY: 40 });
  doc.setFontSize(14);
  doc.text('Employment', 14, doc.autoTable.previous.pageStartY - 5);

  // Sixth Table
  doc.autoTable(columns, sixthTable, { startY: doc.autoTable.previous.finalY + 15 });
  doc.setFontSize(14);
  doc.text('Primary Income', 14, doc.autoTable.previous.pageStartY - 5);

  // Seventh Table
  if (application.additionalIncome.length > 0) {
    doc.autoTable(columns, seventhTable, { startY: doc.autoTable.previous.finalY + 15 });
    doc.setFontSize(14);
    doc.text('Additional Income', 14, doc.autoTable.previous.pageStartY - 5);
  }

  // add a new page
  doc.addPage();

  // Eight Table
  if (!application.noDebts) {
    doc.autoTable(columns, _.flatten(eightTable), { startY: 25 });
    doc.setFontSize(14);
    doc.text('Debts', 14, 15);
  }

  // Ninth Table
  if (!application.noDebts) {
    doc.autoTable(columns, ninthTable, { startY: doc.autoTable.previous.finalY + 15 });
  } else {
    doc.autoTable(columns, ninthTable, { startY: 25 });
  }
  doc.setFontSize(14);
  doc.text('Expenses', 14, doc.autoTable.previous.pageStartY - 5);

  // tenth Table
  doc.autoTable(columns, tenthTable, { startY: doc.autoTable.previous.finalY + 15 });
  doc.setFontSize(14);
  doc.text('Relationship Status', 14, doc.autoTable.previous.pageStartY - 5);

  // add a new page
  if (!application.noDebts) {
    doc.addPage();
  }
  if (!application.noDebts) {
    doc.autoTable(servicingHeader, eleventhTable, { startY: 25 });
    doc.text('Serviceability Results', 14, 15);
    doc.setFontSize(10);
    doc.text(15, 190, notes);
    doc.text('Additional Notes', 14, 160)
  } else {
    doc.autoTable(servicingHeader, eleventhTable, { startY: doc.autoTable.previous.finalY + 15 });
    doc.text('Serviceability Results', 14, doc.autoTable.previous.pageStartY - 5);
    doc.text('Additional Notes', 14, 150)
    doc.setFontSize(10);
    doc.text(15, 160, notes);
  }

  doc.save('SocietyOne_' + application.name)
}

export const lowScorePdf = (application) => {

};



// WEBPACK FOOTER //
// ./src/utils/pdfMethods.js